// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// TODO: This service has two directive communication causing some DOM elements manipulation internally. In
// a next iteration of checks and improvements is importante to try to move the DOM manipulation
// directly to a directive or a controller.
// TODO #2 - We should use the mediaQueryService here and menu directive to do this properly...
class BxRecommenderService {
   $http: any
   $timeout: any
   $window: any
   bxClass: any
   bxStyle: any
   callerEvent: any
   config: any
   currentBehavior: any
   currentId: any
   data: any
   fire: any
   limit: any
   loading: any
   loadingError: any
   menuManager: any
   recommendations: any
   retrievedDocuments: any
   showRecommendations: any
   token: any
   constructor(data: any, $http: any, config: any, $timeout: any, $window: any, hooksService: any, menuManager: any) {
      this.setupViewBehaviors = this.setupViewBehaviors.bind(this)
      this.checkSize = this.checkSize.bind(this)
      this.containerFocus = this.containerFocus.bind(this)
      this.containerUnfocus = this.containerUnfocus.bind(this)
      this.reset = this.reset.bind(this)
      this.getNewLookup = this.getNewLookup.bind(this)
      this.getLookup = this.getLookup.bind(this)
      this.successLookup = this.successLookup.bind(this)
      this.toggleRecommendations = this.toggleRecommendations.bind(this)
      this.successRecommendations = this.successRecommendations.bind(this)
      this.errorHandler = this.errorHandler.bind(this)
      this.close = this.close.bind(this)
      this.imActive = this.imActive.bind(this)
      this.data = data
      this.$http = $http
      this.$timeout = $timeout
      this.$window = $window
      this.menuManager = menuManager
      this.config = config.data.bxRecommender

      hooksService.setHooks(this, 'BxRecommenderService', ['togglingRecommendations'])

      this.bxStyle = {
         sm: {},
         md: {}
      }
      this.bxClass = {
         sm: {
            active: false
         },
         md: {}
      }

      this.recommendations = []
      this.showRecommendations = false
      this.loadingError = false
      this.loading = false
      this.limit = 5
      this.currentId = ''
      this.token = ''

      this.data.on('new', this.getNewLookup)
      this.data.on('update', this.getLookup)

      this.reset()
      this.setupViewBehaviors()
   }

   setupViewBehaviors() {
      // Specific size behaviors
      this.checkSize()

      let lastCheckSizeExecution = false
      return angular.element(this.$window).on('resize', () => {
         if (lastCheckSizeExecution) { this.$timeout.cancel(lastCheckSizeExecution) }
         return lastCheckSizeExecution = this.$timeout(() => {
            this.checkSize()
            return lastCheckSizeExecution = false
         }
         , 100)
      })
   }

   checkSize() {
      return this.currentBehavior = (() => { switch (false) {
      // md or greater sizes
         case this.$window.innerWidth < 1025: return 'md'
            // sm sizes
         case (this.$window.innerWidth >= 1025) || (this.$window.innerWidth < 701): return 'sm'
            //small sizes
         default: return 'xs'
      } })()
   }

   containerFocus() {
      if (this.currentBehavior === 'md') {
         this.menuManager.menu.thirdPanel.openMenu()
      }

      const focus = () => {
         const container = angular.element('.bxRecommenderContainer:visible .content')
         // Focus the dialog for accessibility WITHOUT scrolling. The scroll
         // container is #main and the sticky header overlaps its top, so a
         // default scroll-on-focus pushes the panel (close button and collapse
         // arrow) up under the header. preventScroll keeps the panel in place.
         try { (container[0] as any)?.focus({ preventScroll: true }) }
         catch { container[0]?.focus() }
      }

      this.bxClass.sm['active'] = true
      if (this.currentBehavior === 'sm') {
         return this.$timeout(focus, 750)
      } else {
         return this.$timeout(focus, 10)
      }
   }

   containerUnfocus() {
      return this.bxClass.sm['active'] = false
   }

   reset() {
      // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
      this.close()
      this.loadingError = false
      return this.retrievedDocuments = {}
   }

   getNewLookup(data: any) {
      this.reset()
      return this.getLookup(data)
   }

   getLookup(data: any) {
      if ((data.documents == null) || !data.documents.length) { return }
      const docs = data.documents
      data = this.compoundLookup(docs)
      if (data.length) {
         const promise = this.$http.post("/2.0.0/services/bx/lookup", {bxItems: data})
         return promise.then(this.successLookup)
      }
   }

   compoundLookup(docs: any) {
      return _.compact(docs.map((doc: any) => {
         if (doc.bx_open_url && !this.retrievedDocuments.hasOwnProperty(doc.id)) {
            return {docID: doc.id, bxOpenURL: doc.bx_open_url}
         } else {
            return null
         }
      })
      )
   }

   successLookup({
      data
   }: any) {
      if (!this.token) { this.token = data.bxToken }
      return data.bxIdentifiers.forEach((identifier: any) => {
         if (identifier.bxIdentifier) {
            return this.retrievedDocuments[identifier.docID] = identifier.bxIdentifier
         }
      })
   }

   toggleRecommendations(docId: any, event: any) {
      if (this.retrievedDocuments[docId] == null) { return undefined }

      if (this.currentId === docId) {
         this.close(event)
         return
      }

      this.callerEvent = event.currentTarget

      this.showRecommendations = true
      this.fire('togglingRecommendations')
      this.loading = true
      this.recommendations = []
      this.loadingError = false
      this.limit = 5
      this.currentId = docId

      const promise = this.$http.get(`/bx/recommendations/${this.config.libHash}/${this.retrievedDocuments[docId]}/${this.token}`,
         {cache: true})
      return promise.then(this.successRecommendations, this.errorHandler)
   }

   successRecommendations({
      data
   }: any) {
      // Max recommendations to 10
      const docs = data.documents.slice(0, 10)
      docs.forEach(function(doc: any){
         try {
            return doc.publication_date = (doc.publication_date != null) ? new Date(doc.publication_date).getUTCFullYear() : ''
         } catch (error) {}
      })
      this.recommendations = docs
      this.loading = false
      // Render time
      return this.$timeout(this.containerFocus)
   }

   errorHandler() {
      this.loading = false
      this.loadingError = true
      return this.bxClass.sm['active'] = true
   }

   close(event: any) {
      const closeFn = function (that:any) {
         if (event?.currentTarget !== that.callerEvent) {
            that.$timeout((() => that.callerEvent.focus()), 0)
         }
         that.recommendations = []
         that.showRecommendations = false
         that.currentId = ''
         return that.fire('togglingRecommendations')
      }

      if (this.currentBehavior === 'sm') {
         this.$timeout(closeFn.call(event, this), 750)
      } else {
         closeFn(this)
      }

      return this.containerUnfocus()
   }

   imActive(id: any) {
      return this.currentId === id
   }
}

BxRecommenderService.$inject = ['dataService', '$http', 'configService', '$timeout', '$window', 'hooksService', 'menuManagerService' ]

angular.module('summonApp.services')
   .service('bxRecommenderService', BxRecommenderService)
